import React, { useContext } from "react";
import "./ListDocument.scss";

import { Image } from "@evidenceb/athena-common/modules/Assets";
import { VisuallyHidden } from "@evidenceb/athena-common/ui/VisuallyHidden";
import { defineMessages, useIntl } from "react-intl";
import useAssetsDetails from "../../../../hooks/useAssetsDetails";
import classNames from "classnames";
import { configStore } from "../../../../contexts/ConfigContext";
import { Classroom, Student } from "../../../../interfaces/User";
import { commonMessages } from "../../../../utils/messages";
import { fullName } from "../../../../utils/format";
import { MAX_STUDENTS_PER_COLUMN } from "../UsersCodeDocument";
interface Props {
    classroom: Classroom;
    pageIndex: number;
    page: Student[][];
}
const ListDocument = ({ classroom, page, pageIndex }: Props) => {
    const intl = useIntl();
    return (
        <div
            className={classNames("list-document", {
                "--single-column":
                    page.flat().length <= MAX_STUDENTS_PER_COLUMN,
            })}
        >
            <PdfHeader
                classroom={classroom}
                className={classNames({
                    "header-for-print-only": pageIndex !== 0,
                })}
            />
            <div className="list-document__tables">
                {page.map((table, i) => (
                    <table key={i}>
                        <caption>
                            <VisuallyHidden>
                                {intl.formatMessage(
                                    messages.usersCodeDocTableCaption
                                )}
                            </VisuallyHidden>
                        </caption>
                        {table.map((student) => {
                            const name = fullName(student, {
                                startWithLastName: true,
                            });
                            return (
                                <tr key={student.id}>
                                    <th scope="row">
                                        <div>{name}</div>
                                    </th>
                                    <td>
                                        <div>{student.code}</div>
                                    </td>
                                </tr>
                            );
                        })}
                    </table>
                ))}
            </div>
        </div>
    );
};

export default ListDocument;

interface PdfHeaderProp {
    classroom: Classroom;
    className?: string;
}

const PdfHeader = ({ classroom, className }: PdfHeaderProp) => {
    const intl = useIntl();
    const { config } = useContext(configStore);
    const assetsDetails = useAssetsDetails();
    return (
        <>
            <header className={classNames("list-document__header", className)}>
                <div className="list-document__header__title">
                    <h1>
                        {intl.formatMessage(messages.usersCodeDocTitle, {
                            client: config.client_name,
                        })}
                    </h1>
                    <span className="list-document__header__class-name">
                        {classroom.name}
                    </span>
                </div>
                <div className="list-document__header__logo">
                    <Image
                        assetsDetails={assetsDetails}
                        src={config.logos.pdfLogo ?? config.logos.header_client}
                        alt=""
                    />
                </div>
            </header>
            <div className="list-document__class-code">
                <div>
                    {intl.formatMessage(commonMessages.classroomCode)}
                    {config.logos.mascotIcon && (
                        <Image
                            className="list-document__class-code__mascot"
                            assetsDetails={assetsDetails}
                            src={config.logos.mascotIcon}
                            alt=""
                        />
                    )}
                </div>
                <div>{classroom.code}</div>
            </div>
            <h2>{intl.formatMessage(commonMessages.studentCode)}</h2>
        </>
    );
};

const messages = defineMessages({
    usersCodeDocTitle: {
        id: "dashboard-codeDocument-title",
        defaultMessage: "Connexion to {client}",
    },
    usersCodeDocTableCaption: {
        id: "dashboard-codeDocument-tableCaption",
        defaultMessage: "List of students and their connection codes",
    },
});
